const toCurrency = (value, deduction) => {
    if (typeof value !== "number") {
        if (deduction) {
            return '-$' + value.trim();    
        }
        return '$' + value.trim();
    }
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    });
    if (deduction) {
        return '-' + formatter.format(value);
    }
    return formatter.format(value);
};

export default toCurrency;